import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Card,
  Grid,
  Button,
  Divider,
  CardActions,
  CardContent,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  }
}));

const PartnerCardPreview = forwardRef(({
  className, partner, onUpload, hasImage, ...rest
}, ref) => {
  const classes = useStyles();
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    ref?.current?.addEventListener('change', () => {
      setPreviewImage(URL.createObjectURL(ref?.current?.files[0]));
    });
  }, []);

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="partner"
              src={previewImage || partner?.avatar}
              variant="square"
            />
          </Grid>
          <Grid item xs={9}>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="h4"
            >
              {partner?.first_name}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="h4"
            >
              {partner?.last_name}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
            >
              {partner?.email}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
            >
              {partner?.phone}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      {
        !hasImage && (
          <>
            <Divider />
            <CardActions>
              <Button
                color="primary"
                fullWidth
                variant="text"
                onClick={onUpload}
              >
                Subir Foto
              </Button>
            </CardActions>
          </>
        )
      }
    </Card>
  );
});

PartnerCardPreview.propTypes = {
  className: PropTypes.string,
  partner: PropTypes.object,
  hasImage: PropTypes.bool,
  onUpload: PropTypes.func,
};

PartnerCardPreview.defaultProps = {
  className: '',
  partner: {},
  hasImage: false,
  onUpload: () => {},
};

export default PartnerCardPreview;
